module.exports = __webpack_public_path__ + "static/img/cardboard.21b92db.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/package-service/cardboard.png
// module id = O5uc
// module chunks = 2